import { createSelector } from '@opengov/compose-app/reselect';
import { getRouteName } from '@opengov/compose-app-router/selectors';
import { selectReactRouterRouteName } from '../../report/selectors/reportSelectors';

export const selectRouteName = createSelector(
  getRouteName,
  selectReactRouterRouteName,
  (routeName, reactRouterRouteName) => {
    return routeName || reactRouterRouteName;
  }
);
